import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAtlassianComponent } from './simple-icons-atlassian.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAtlassianComponent ],
    exports:      [ SimpleIconsAtlassianComponent ],
    bootstrap:    []
})
export class SimpleIconsAtlassianModule {}
